// Random stock house image shown for a property with no photo yet - shared
// by the inventory list pages and the chat preview card. Kept out of
// PropertyInventoryListing.js (which imports react-slick at module load for
// its own carousel) so a call site that just wants this array, like the
// chat card, doesn't drag a carousel library into its bundle - and, in
// Jest, doesn't hit enquire.js's window.matchMedia crash in jsdom.
export const emptyPropertyPlaceholderImages = [
  "house-empty-placeholder-01.png",
  "house-empty-placeholder-02.png",
  "house-empty-placeholder-03.png",
  "house-empty-placeholder-04.png",
];
